/* eslint-disable */
import axios from 'axios'

const flightSearchService = {
    getFlightInfo(searchId, priceBox,depFlightGrpId, rtnFlightGrpId){
        //alert(searchId);
        return new Promise((resolve)=>{
            
            let priceBoxDepartures = priceBox.Departures.filter(f=>f.Flight.GroupFlightID === depFlightGrpId);
            let priceBoxReturns = priceBox.Returns.filter(f=> f.Flight.GroupFlightID === rtnFlightGrpId);
            
            let pricingBoxMini= {
                PricingBoxID:priceBox.PricingBoxID,
                Departures: priceBoxDepartures,
                Returns: priceBoxReturns,
                AccountCode: priceBox.AccountCode,
                PlatingCarrier:""               
            };

            let postData = {
                srchId:searchId,prcBox:pricingBoxMini,departure_group_id:depFlightGrpId,return_group_id:rtnFlightGrpId
            };

            axios.post("/api/Flight2C_1/ShowConfirmFareForResponsive",
                postData
            ).then(rslt=>{
                resolve(rslt.data);
            }
            ).catch(()=>{
                console.error;
            });
        })
    },
    getFlightInfoM(searchId, pricegrp,depFlightGrpId){
        //alert(searchId);
        return new Promise((resolve)=>{
            let PricingGroupBoxMini=[];           
            pricegrp.PricingBoxGroup.forEach(prigrp => {               
                prigrp.PricingBox.forEach(priceBox => {         
                    let priceBoxDepartures = priceBox.Departures
                      .filter(f=> depFlightGrpId.indexOf(f.Flight.GroupFlightID)>=0);  
                    if (priceBoxDepartures && priceBoxDepartures.length >0){
                        let pricingBoxMini= {
                          PricingBoxID:priceBox.PricingBoxID,
                          Departures: priceBoxDepartures,
                          Returns: priceBox.Returns,
                          AccountCode: priceBox.AccountCode,
                          PlatingCarrier:priceBox.PlatingCarrier               
                      };
                      PricingGroupBoxMini.push(pricingBoxMini);
                    }         

                });
            });
            
            let postData = {
                srchId:searchId,prcGrpBox:PricingGroupBoxMini,departure_group_ids:depFlightGrpId
            };


            axios.post("/api/Flight2C_1/ShowConfirmFareForResponsiveM",
                postData
            ).then(rslt=>{
                resolve(rslt.data);
            }
            ).catch((error)=>{
                throw error
            });
        })
    },
    saveFareInfoOfSearch(priceBox,depFlightGrpId, rtnFlightGrpId){
        return new Promise((resolve)=>{
            axios.post("/api/Flight2C_1/NextStep_Responsive",
            {
                box_group_id: priceBox,
                departure_group_id: depFlightGrpId,
                return_group_id: rtnFlightGrpId               
            }).then(rslt=>{
                resolve(rslt.data);
            }).catch(()=>{
                console.error;
            });
        });
    },
    saveFareInfoOfSearchM(priceBox,depFlightGrpId){
        return new Promise((resolve)=>{            
            axios.post("/api/Flight2C_1/NextStep_ResponsiveM",
            {
                box_group_ids: priceBox,
                departure_group_ids: depFlightGrpId          
            }).then(rslt=>{
                resolve(rslt.data);
            }).catch((error)=>{
                resolve(error)
            });
        });
    }
}

export default flightSearchService